import { nl2br as n } from "../../utils.js";
const i = (t) => Object.entries(t || {}).filter(([, o]) => o == null ? void 0 : o.length).map(([o, e]) => ({
  key: `shopLanding.legal.${o}`,
  value: n(e, !0)
})) ?? [];
export {
  i as convertShopLegalToModalLinks
};
//# sourceMappingURL=utils.js.map
